// src/string/constants.ts
var whitespace = Symbol("whitespace");

// src/string/trimEnd.ts
function trimEnd(str, chars = whitespace) {
  if (chars === whitespace) {
    return str.trimEnd();
  } else {
    return str.endsWith(chars) ? str.slice(0, -chars.length) : str;
  }
}

// src/string/trimStart.ts
function trimStart(str, chars = whitespace) {
  if (chars === whitespace) {
    return str.trimStart();
  } else {
    return str.startsWith(chars) ? str.slice(chars.length) : str;
  }
}

// src/string/humanFileSize.ts
function humanFileSize(bytes, useMetricUnits = false, decimalPlaces = 1) {
  const thresh = useMetricUnits ? 1e3 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  const units = useMetricUnits ? ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let unitIndex = -1;
  const r = 10 ** decimalPlaces;
  do {
    bytes /= thresh;
    ++unitIndex;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && unitIndex < units.length - 1);
  return bytes.toFixed(decimalPlaces) + " " + units[unitIndex];
}
export { humanFileSize, trimEnd, trimStart, whitespace };